import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link } from '@mui/material';
import type { MarketingNavItem } from '../../marketing/marketingNav';
import { isLandingPath, scrollToMarketingHash } from '../../marketing/marketingHash';
import { useT } from '../../i18n/useT';

type Props = {
  item: MarketingNavItem;
  heroMode?: boolean;
  onNavigate?: () => void;
};

function splitMarketingHref(href: string) {
  const hashIdx = href.indexOf('#');
  if (hashIdx === -1) return { path: href, hash: '' };
  return {
    path: href.slice(0, hashIdx) || '/landing',
    hash: href.slice(hashIdx),
  };
}

export default function MarketingNavLink({ item, onNavigate }: Props) {
  const t = useT();
  const location = useLocation();
  const { path, hash } = splitMarketingHref(item.href);
  const label = t(item.labelKey);

  if (!hash) {
    return (
      <Link
        component={RouterLink}
        to={item.href}
        className="landing-nav-link"
        underline="none"
        color="inherit"
        onClick={() => onNavigate?.()}
      >
        {label}
      </Link>
    );
  }

  return (
    <Link
      href={`${path}${hash}`}
      className="landing-nav-link"
      underline="none"
      color="inherit"
      onClick={(e) => {
        e.preventDefault();
        onNavigate?.();
        if (isLandingPath(location.pathname)) {
          window.history.replaceState(null, '', `${path}${hash}`);
          scrollToMarketingHash(hash);
          return;
        }
        window.location.assign(`${path}${hash}`);
      }}
    >
      {label}
    </Link>
  );
}
